import React from "react";

import "./TermlyPolicyEmbed.css";

function getPolicyViewerUrl(policyId){
  return `https://app.termly.io/policy-viewer/policy.html?policyUUID=${policyId}`;
}

export default function TermlyPolicyEmbed({ policyId, policyName }){
  const [iframeReady, setIframeReady] = React.useState(false);
  const [reloadKey, setReloadKey] = React.useState(0);

  const viewerUrl = getPolicyViewerUrl(policyId);

  return (
    <div className="termly-policy-shell">
      {!iframeReady && (
        <div className="termly-policy-status" aria-live="polite">
          <span className="termly-policy-spinner" aria-hidden="true" />
          Loading {policyName} from Termly...
        </div>
      )}

      <iframe
        key={`${policyId}-${reloadKey}`}
        title={`${policyName} hosted by Termly`}
        src={viewerUrl}
        className="termly-policy-iframe"
        loading="eager"
        referrerPolicy="no-referrer-when-downgrade"
        onLoad={() => setIframeReady(true)}
      />

      <div className="termly-policy-actions">
        <button
          type="button"
          className="termly-policy-retry"
          onClick={() => {
            setIframeReady(false);
            setReloadKey((key) => key + 1);
          }}
        >
          Reload {policyName}
        </button>
        <a
          href={viewerUrl}
          target="_blank"
          rel="noreferrer"
          className="termly-policy-open"
        >
          Open in a new tab
        </a>
      </div>
    </div>
  );
}
